import React, { useState, useEffect } from "react";
import { Tooltip } from "react-tooltip";

const Slider = ({
  label,
  unit,
  min,
  max,
  stepCount,
  value,
  setValue,
  defaultValue,
}) => {
  // Calculate step value for internal use, ensuring smooth slider adjustments
  const stepValue = (max - min) / stepCount;
  const thumbWidth = 40;
  const [thumbPosition, setThumbPosition] = useState(0);

  useEffect(() => {
    const newPosition = ((value - min) / (max - min)) * 100;
    setThumbPosition(newPosition);
  }, [value, min, max]);

  const handleSliderChange = (event) => {
    // Convert string value to float and round to nearest integer
    const newValue = parseFloat(event.target.value);
    const snappedValue = Math.round(newValue); // Ensure value is an integer
    setValue(snappedValue); // Update state in parent component
  };

  const handleInputChange = (event) => {
    let inputValue = event.target.value.replace(",", ".");
    // Remove non-numeric characters except decimal point, then convert to float
    inputValue = inputValue.replace(/[^0-9.]+/g, "");
    let numericValue = parseFloat(inputValue);
    if (!isNaN(numericValue)) {
      // Clamp the value between min and max, then round to nearest integer
      numericValue = Math.max(min, Math.min(numericValue, max));
      const snappedValue = Math.round(numericValue);
      setValue(snappedValue); // Update state in parent component
    } else {
      // Reset to min if input is not a number
      setValue(min);
    }
  };

  const formatValueForInput = (value) => {
    // Locale formatting for the input value display
    return Number(value).toLocaleString("fr-FR");
  };

  // Generating marks for the slider
  const marks = Array.from({ length: stepCount + 1 }, (_, index) => {
    const mark = min + index * stepValue;
    return Math.round(mark); // Ensure marks are integers
  });

  const valueDisplayStyle = {
    left: `calc(${thumbPosition}% - ${thumbWidth / 2}px)`, // Adjust to properly center the value display
  };

  return (
    <div className="slider-container">
      <div className="slider-labels">
        <span>{label}</span>
        <div className="input-container">
          <input
            type="text"
            className="value"
            value={formatValueForInput(value)}
            onChange={handleInputChange}
          />
          <div className="unit">{unit}</div>
        </div>
      </div>
      <input
        type="range"
        min={min}
        max={max}
        value={value}
        step={"any"} // Allows for smooth dragging
        onChange={handleSliderChange}
        className="slider"
      />

      <div className="slider-value my-anchor-element" style={valueDisplayStyle}>
        {formatValueForInput(value)}
      </div>

      <Tooltip anchorSelect=".my-anchor-element" place="top">
        {formatValueForInput(value)}
      </Tooltip>

      <div className="slider-marks">
        {marks.map((mark, index) => (
          <span
            key={index}
            className="slider-mark"
            style={{ left: `${(index / stepCount) * 100}%` }}
          >
            {index >= 0 ? mark.toLocaleString("fr-FR") : ""}
          </span>
        ))}
      </div>
    </div>
  );
};

export default Slider;
